import { SceneGraphNode } from '../../models/scene-graph-node';
import { StrToBool } from './serialize-graph-types';
import { SerializeGraphUtils } from './serialize-graph-utils';

/* Serialize the Scene Graph for Module File Export
 */

export function serializeGraph(rootObjects, excludeMap: StrToBool): SceneGraphNode[] {
  const sceneGraph: SceneGraphNode[] = [];
  Object.entries(rootObjects).forEach(([id, rootObject]) => {
    const rootNode = SerializeGraphUtils.serializeHumanObject(rootObject, excludeMap);

    if (rootNode !== null) {
      sceneGraph.push(rootNode);
    }
  }, this);

  return sceneGraph;
}
